<template>
  <div class="step-4">
    <p>{{ $t('procedures.steps.fourth.firstParagraphe') }}</p>
    <p>{{ $t('procedures.steps.fourth.secondParagraphe') }}</p>
    <ul class="step-4__list">
      <li>{{ $t('procedures.steps.fourth.list.first') }}</li>
      <li>{{ $t('procedures.steps.fourth.list.second') }}</li>
      <li>{{ $t('procedures.steps.fourth.list.third') }}</li>
    </ul>
    <p>{{ $t('procedures.steps.fourth.thirdParagraphe') }}</p>
    <valor-declaration />
    <template v-if="isMinarm">
      <h3>{{ $t('procedures.minarmSteps.fourth.secondTitle') }}</h3>
      <p>{{ $t('procedures.minarmSteps.fourth.secondTitleSub') }}</p>
      <div class="step-4__panel">
        <div class="step-4__panel--heading">
          <h4 class="step-4__panel--heading__title">
            <font-awesome-icon icon="angle-down"/>
            {{ $t('procedures.minarmSteps.fourth.panel.title') }}
          </h4>
        </div>
        <div class="step-4__panel--body">
          <p>{{ $t('procedures.minarmSteps.fourth.panel.firstParagraphe') }}</p>
          <ol class="step-4__panel--body__list">
            <li
              class="step-4__panel--body__list--li"
              v-html="$t('procedures.minarmSteps.fourth.panel.firstList')">
            </li>
            <li
              class="step-4__panel--body__list--li"
              v-html="$t('procedures.minarmSteps.fourth.panel.secondList')">
            </li>
            <li
              class="step-4__panel--body__list--li">
              {{ $t('procedures.minarmSteps.fourth.panel.thirdList') }}
            </li>
            <li
              class="step-4__panel--body__list--li">
              {{ $t('procedures.minarmSteps.fourth.panel.fourthList') }}
            </li>
          </ol>
          <p>
            {{ $t('procedures.minarmSteps.fourth.panel.secondParagraphe') }}
          </p>
          <p class="step-4__panel--body__action">
            <el-link target="_blank"
                     class="button-link"
                     :underline="false"
                     :href="closeFileLinkOnline">
              {{ $t('procedures.minarmSteps.fourth.panel.closeFileOnline') }}
            </el-link>
            <el-link target="_blank"
                     class="button-link"
                     :underline="false"
                     :href="closeFileLink">
              {{ $t('procedures.minarmSteps.fourth.panel.closeFile') }}
            </el-link>
          </p>
        </div>
      </div>
      <div
        class="step-4__panel--documents">
        <h3>{{ $t('procedures.minarmSteps.fourth.documents.title') }}</h3>
        <div v-if="demandStore.documents.invoice || demandStore.documents.lv || downloadOfferUrl">
          <p>
            {{ $t('procedures.minarmSteps.fourth.documents.firstParagraphe') }}
          </p>
          <div class="step-4__panel--documents--links">
            <el-link
              v-if="downloadOfferUrl"
              target="_blank"
              class="button-link"
              :underline="false"
              :href="downloadOfferUrl">
              {{ $t('procedures.minarmSteps.fourth.documents.signedQuote') }}
            </el-link>
            <el-link
              v-if="demandStore.documents.invoice"
              target="_blank"
              class="button-link"
              :underline="false"
              :href="demandStore.documents.invoice">
              {{ $t('procedures.minarmSteps.fourth.documents.facture') }}
            </el-link>
            <el-link
              v-if="demandStore.documents.lv"
              target="_blank"
              class="button-link"
              :underline="false"
              :href="demandStore.documents.lv">
              {{ $t('procedures.minarmSteps.fourth.documents.waybill') }}
            </el-link>
          </div>
        </div>
        <div v-else>
          <p>
            {{ $t('procedures.minarmSteps.fourth.documents.empty') }}
          </p>
        </div>
      </div>
    </template>
    <div>
      <template v-if="isMinarm">
        <h3>{{ $t('procedures.steps.fourth.disput.title') }}</h3>
        <p>
          {{ $t('procedures.steps.fourth.disput.firstParagraphe') }}
        </p>
      </template>
      <template v-else>
        <h3>{{ $t(getTextType('procedures.steps.fourth.disput.title')) }}</h3>
        <p>
          {{ $t(getTextType('procedures.steps.fourth.disput.firstParagraphe')) }}
        </p>
      </template>
      <p>
        {{ $t('procedures.steps.fourth.disput.secondParagraphe') }}
      </p>
      <router-link class="step-4__panel--disput--redirect"
                   :to="{ name: 'contact' }">
        <el-link
          class="button-link step-4__panel--disput--redirect--link"
          :underline="false">
          {{ $t('procedures.steps.fourth.disput.button') }}
        </el-link>
      </router-link>
    </div>
  </div>
</template>

<script>
import demandHelper from '@/utils/helpers/demand';
import StepWrapper from '@/components/procedures/prebookStepper/steps/StepWrapper.vue';
import valorDeclaration from '@/components/procedures/prebookStepper/ValorDeclaration.vue';

export default {
  name: 'step4',
  extends: StepWrapper,
  components: {
    valorDeclaration,
  },
  computed: {
    closeFileLink() {
      if (demandHelper.isInternational(this.demandStore)) {
        return this.$t('procedures.minarmSteps.fourth.panel.closeFileLinkInter');
      }
      return this.$t('procedures.minarmSteps.fourth.panel.closeFileLink');
    },
    closeFileLinkOnline() {
      if (demandHelper.isInternational(this.demandStore)) {
        return this.$t('procedures.minarmSteps.fourth.panel.closeFileLinkOnlineInter');
      }
      return this.$t('procedures.minarmSteps.fourth.panel.closeFileLinkOnline');
    },
    downloadOfferUrl() {
      return this.signedOffer && this.signedOffer.url;
    },
  },
};
</script>

<style lang="scss" scoped>

.step-4 {
  &__list {
    color: $--color-font;
  }
  &__panel {
    box-shadow: 0 1px 2px rgba(0,0,0,.05);
    background-color: $--color-light-grey;
    border-radius: 4px;
    margin: 20px 0;
    &--heading {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      background-color: $--color-light-blue-grey;
      padding: 5px 10px;
      &__title {
        margin: 0;
      }
    }
    &--body {
      font-size: 15px;
      padding: 15px 20px;
      &__list {
        color: $--color-font;
        &--li {
          margin-bottom: 0.3em;
        }
      }
      &__action {
        text-align: center;
        .button-link {
          margin: 5px;
         }
      }
      ol {
        padding-left: 20px;
      }
    }
    &--documents {
      margin: 20px 0;
      &--links {
        .el-link:nth-child(2) {
          margin-left: 10px;
        }
      }
    }
    &--disput {
      &--link {
        font-size: 16px;
      }
      &--redirect {
        text-decoration: none;
        &--link {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
